"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.costReports.title': '成本报告',
    'reports.costReports.description': '查看AI使用成本和分析',
};
